"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21.781 2.219a.746.746 0 0 1 0 1.055L3.274 21.781a.746.746 0 1 1-1.055-1.055L20.726 2.219a.746.746 0 0 1 1.055 0M3.349 5.02c.525-1.13 1.691-1.975 3.186-1.975h10.44a.696.696 0 1 1 0 1.393H6.536c-.938 0-1.62.517-1.923 1.169-.3.646-.234 1.431.374 2.049l4.103 4.168a.696.696 0 1 1-.993.977L3.993 8.633C2.95 7.572 2.822 6.155 3.35 5.02m16.652 2.628c.274.27.277.71.007.985l-5.05 5.13a.57.57 0 0 0-.17.402v4.127c0 1.51-1.289 2.663-2.787 2.663-1.499 0-2.787-1.153-2.787-2.663v-.82a.697.697 0 0 1 1.393 0v.82c0 .662.583 1.27 1.394 1.27s1.394-.608 1.394-1.27v-4.127c0-.519.208-1.01.57-1.379l5.05-5.13a.697.697 0 0 1 .986-.008",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FilterOffIcon24.js.map